module.exports = __webpack_public_path__ + "img/star-map_backgrounds-white_and_gold.b866bba.webp";